module.exports = __webpack_public_path__ + "7cec81d5dba09be0758150ba60459829.svg";